import { Role } from "../../roles/_types/role";
import { minLength, prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { UserType } from "./user-type";

export class User extends Resource {
    public override type = 'users';

    @prop()
    @required()
    @minLength({ value: 3 })
    public name!: string;

    @prop()
    public email!: string;

    @prop()
    public vatNumber?: string | null;

    @prop()
    @required()
    public userName!: string;

    @prop()
    @required()
    public password!: string;

    @prop()
    public temporalPassword?: string | null;

    @prop()
    public active: boolean = true;

    @prop()
    @required()
    public roleId!: string;

    @prop()
    @required()
    public languageId!: string;

    @prop()
    public role!: Role;

    @prop()
    public enableSIPExtension: boolean = false;

    @prop()
    public sipExtension!: string;

    @prop()
    public sipExtensionPassword!: string;

    @prop()
    public sipTransport: string = 'transport-tcp';

    @prop()
    public outboundDDIId!: string;

    @prop()
    public userTypeId!: string;

    @prop()
    public userType!: UserType;

    @prop()
    @required()
    public maxServiceEvaluatedPercent: number = 100;


    
    @prop()
    public absence: boolean = false;
    
    @prop()
    public max_cases_actives!: number;
    
    @prop()
    public max_cases_day!: number;

    @prop()
    public capacityPercent: number = 100;

    @prop()
    public enableWorkerSeizureNotification: boolean = false;

    @prop()
    public enableVehiclePolizyExpiredNotification: boolean = false;

    @prop()
    public enableHolidaysNotification: boolean = false;
    
    @prop()
    public enableKeepGuardShiftNotification: boolean = false;
    
    @prop()
    public enableOperatorRejectAllDayNotification: boolean = false;
    
    @prop()
    public enableClientCompensationNotification: boolean = false;

    @prop()
    public isWorker: boolean = false;

    @prop()
    public isExternalUser: boolean = false;

    @prop()
    public secondUserId?: string;
    @prop()
    public secondUser!: User;
    
    @prop()
    public workerUserId?: string;
    @prop()
    public workerUser!: User;

}